import React, { useEffect, useState } from "react";
import Pagination from "react-bootstrap/Pagination";
import {
    Container,
    Row,
    Col,
    Card,
    Table,
    Badge,
} from "react-bootstrap";
import { getWallet } from "../../store/slices/user";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";


export default function Wallets() {
    const dispatch = useDispatch();
    const navigate = useNavigate()

    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 10;

    const {
        wallet,
        walletTransactions,
    } = useSelector(
        (state) => state.user
    );

    useEffect(() => {
        dispatch(getWallet());
    }, [dispatch]);


    const totalPages = Math.ceil(
        (walletTransactions?.length || 0) / itemsPerPage
    );

    const currentData =
        walletTransactions?.slice(
            (currentPage - 1) * itemsPerPage,
            currentPage * itemsPerPage
        ) || [];




    return (

        <>

            <div className="breadcrumb-bar mb-2 mx-1">
                <div className="container-fluid">
                    <div className="d-flex flex-row flex-md-row align-items-md-center justify-content-between gap-2 py-2">

                        <div className="breadcrumb-left d-flex align-items-center flex-wrap">
                            <Link to="/user/home" className="breadcrumb-link active my-2">
                                Home
                            </Link>

                            <span className="breadcrumb-separator mx-2">
                                <i className="bi bi-chevron-right"></i>
                            </span>

                            <span
                                className="breadcrumb-link inactive"

                            >
                                Wallet
                            </span>
                        </div>



                    </div>
                </div>
            </div>

            <div className="wallet-page-wrapper">

                <Container fluid>



                    <Row className="g-4 mb-4">

                        <Col xl={4} lg={5} md={6}>

                            <Card className="balance-card">

                                <div className="balance-icon">

                                    <i className="bi bi-wallet2"></i>

                                </div>

                                <div>

                                    <p className="balance-label">
                                        Available Balance
                                    </p>

                                    <h2 className="balance-amount">
                                        ₹{wallet?.availableBalance || 0}
                                    </h2>

                                </div>

                            </Card>

                        </Col>

                        <Col xl={8} lg={7} md={6}>

                            <Card className="coming-soon-card">

                                <div className="coming-left">

                                    <div className="coming-icon">

                                        <i className="bi bi-lock-fill"></i>

                                    </div>

                                    <div>

                                        <h5>
                                            Wallet to Fund Transfer
                                        </h5>


                                    </div>

                                </div>
                                <Badge
                                    className="coming-badge"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => navigate("/user/withdraw")}
                                >
                                    Withdraw Now
                                </Badge>

                            </Card>

                        </Col>

                    </Row>

                    {/* QUICK INFO */}

                    <Row className="g-4 mb-4">

                        <Col lg={3} md={6}>

                            <Card className="info-card">

                                <div className="info-icon sky-bg">

                                    <i className="bi bi-arrow-left-right"></i>

                                </div>

                                <h6>Total Transfers</h6>

                                <h3>{walletTransactions?.length || 0}</h3>

                            </Card>

                        </Col>

                        <Col lg={3} md={6}>

                            <Card className="info-card">

                                <div className="info-icon green-bg">

                                    <i className="bi bi-check-circle-fill"></i>

                                </div>

                                <h6>Successful</h6>
                                <h3>
                                    {
                                        walletTransactions?.filter(
                                            (item) => item.status === "COMPLETED"
                                        ).length || 0
                                    }
                                </h3>

                            </Card>

                        </Col>

                        <Col lg={3} md={6}>

                            <Card className="info-card">

                                <div className="info-icon orange-bg">

                                    <i className="bi bi-clock-history"></i>

                                </div>

                                <h6>Pending</h6>

                                <h3>
                                    {
                                        walletTransactions?.filter(
                                            (item) => item.status === "PENDING"
                                        ).length || 0
                                    }
                                </h3>

                            </Card>

                        </Col>

                        <Col lg={3} md={6}>

                            <Card className="info-card">

                                <div className="info-icon red-bg">

                                    <i className="bi bi-x-circle-fill"></i>

                                </div>

                                <h6>Rejected</h6>
                                <h3>
                                    {
                                        walletTransactions?.filter(
                                            (item) => item.status === "FAILED"
                                        ).length || 0
                                    }
                                </h3>

                            </Card>

                        </Col>

                    </Row>

                    <Row>
                        <div className="p-3">
                            <h5 className="mb-0">
                                Wallet Transfer History
                            </h5>

                        </div>

                    </Row>

                    {/* TABLE */}

                    <Card className="ud-table-card">
                        <div className="ud-scroll-wrap">

                            <Table className="ud-table align-middle mb-0">

                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Referral/ Withdraw</th>
                                        <th>Type</th>
                                        <th>Amount</th>
                                        <th>Date</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {currentData?.map((item, index) => (

                                        <tr key={item._id}>

                                            <td>
                                                {(currentPage - 1) * itemsPerPage + index + 1}
                                            </td>

                                            <td>

                                                <span>
                                                    {item.referredUser?.name || "-"}
                                                </span>


                                            </td>

                                            <td>
                                                <span className="ud-ref-badge">
                                                    {item.type}
                                                </span>
                                            </td>

                                            <td>₹{item.amount}</td>

                                            <td>
                                                {new Date(
                                                    item.createdAt
                                                ).toLocaleDateString()}
                                            </td>

                                            <td>

                                                <span
                                                    className={`ud-status-badge ${item.status === "COMPLETED"
                                                        ? "ud-status-active"
                                                        : "ud-status-pending"
                                                        }`}
                                                >
                                                    {item.status}
                                                </span>

                                            </td>

                                        </tr>

                                    ))}

                                </tbody>

                            </Table>

                        </div>

                    </Card>

                    {totalPages > 1 && (

                        <div className="ud-pagination-wrap">

                            <Pagination className="ud-pagination">

                                <Pagination.Prev
                                    disabled={currentPage === 1}
                                    onClick={() =>
                                        setCurrentPage((prev) => prev - 1)
                                    }
                                />

                                {[...Array(totalPages)].map((_, index) => (

                                    <Pagination.Item
                                        key={index + 1}
                                        active={currentPage === index + 1}
                                        onClick={() =>
                                            setCurrentPage(index + 1)
                                        }
                                    >
                                        {index + 1}
                                    </Pagination.Item>

                                ))}

                                <Pagination.Next
                                    disabled={currentPage === totalPages}
                                    onClick={() =>
                                        setCurrentPage((prev) => prev + 1)
                                    }
                                />

                            </Pagination>

                        </div>

                    )}

                </Container>

            </div>
        </>

    );
};

